import { T } from "../../../i18n/social";
import React, { useState } from "react";

const LightInput = ({ label, type = 'text', placeholder, value, onChange, error, required }) => {
  const [focused, setFocused] = useState(false);
  return (
    <div style={{ marginBottom: '0' }}>
      {label && (
        <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#3E4954', marginBottom: '6px', fontFamily: 'var(--font-ui)' }}>
          {label}
        </label>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          width: '100%',
          height: '48px',
          padding: '0 14px',
          border: error ? '1px solid #dc2626' : focused ? '1px solid #3E4954' : '1px solid #dde1e7',
          borderRadius: '10px',
          fontFamily: 'var(--font-ui)',
          fontSize: '14px',
          color: '#1e2b38',
          background: '#ffffff',
          outline: 'none',
          transition: 'border-color 200ms ease, box-shadow 200ms ease',
          boxShadow: error ? '0 0 0 3px rgba(220,38,38,0.08)' : focused ? '0 0 0 3px rgba(62,73,84,0.08)' : 'none',
        }}
      />
      {error && (
        <p style={{ fontSize: '12px', color: '#dc2626', marginTop: '4px', fontFamily: 'var(--font-ui)' }}>{error}</p>
      )}
    </div>
  );
};

const StepContactForm = ({ formData, onChange, onNext, onBack, onEmailCapture, lang, stepBadge }) => {
  const tc = lang && T[lang]?.steps?.contact ? T[lang].steps.contact : T['de'].steps.contact;
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    if (!formData?.vorname?.trim()) errs.vorname = tc.errVorname;
    if (!formData?.nachname?.trim()) errs.nachname = tc.errNachname;
    if (!formData?.email?.trim()) errs.email = tc.errEmail;
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.email)) errs.email = "Ungültige E-Mail-Adresse";
    if (!formData?.telefon?.trim()) errs.telefon = tc.errTelefon;
    return errs;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    const errs = validate();
    if (Object.keys(errs)?.length > 0) { setErrors(errs); return; }
    setErrors({});
    // Capture email for recovery
    if (onEmailCapture && formData?.email) {
      onEmailCapture(formData.email, formData.vorname, formData.nachname, `${(formData.telefonPrefix || '+49').trim()} ${(formData.telefon || '').replace(/^[+\s]+/, '')}`.trim());
    }
    onNext();
  };

  const handleChange = (field) => (e) => {
    onChange(field, e?.target?.value);
    if (errors?.[field]) setErrors((prev) => { const n = { ...prev }; delete n?.[field]; return n; });
  };

  return (
    <div className="booking-card step-enter">
      {stepBadge && <div className="step-badge">{stepBadge}</div>}

      <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '26px', fontWeight: 700, color: '#1e2b38', marginBottom: '8px', lineHeight: 1.2, letterSpacing: '-0.02em' }}>
        {tc.title || (lang === "uk" ? "Ваші дані" : lang === "ru" ? "Ваши данные" : "Deine Kontaktdaten")}
      </h2>
      <p style={{ fontSize: '14px', color: '#6b7a8d', marginBottom: '24px', fontFamily: 'var(--font-ui)' }}>
        {lang === 'uk' ? 'Усі поля, позначені *, є обов\'язковими.' : lang === 'ru' ? 'Все поля, отмеченные *, обязательны.' : 'Alle mit * markierten Felder sind Pflichtfelder.'}
      </p>

      <form onSubmit={handleSubmit} noValidate>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
          <LightInput
            label={tc.vorname}
            placeholder="Max"
            value={formData?.vorname || ""}
            onChange={handleChange("vorname")}
            error={errors?.vorname}
            required
          />
          <LightInput
            label={tc.nachname}
            placeholder="Mustermann"
            value={formData?.nachname || ""}
            onChange={handleChange("nachname")}
            error={errors?.nachname}
            required
          />
        </div>

        <div style={{ marginBottom: '12px' }}>
          <LightInput
            label={tc.email}
            type="email"
            placeholder="max.mustermann@email.de"
            value={formData?.email || ""}
            onChange={handleChange("email")}
            error={errors?.email}
            required
          />
        </div>

        <div style={{ marginBottom: '12px' }}>
          <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#3E4954', marginBottom: '6px', fontFamily: 'var(--font-ui)' }}>
            {tc.telefon}
          </label>
          <div style={{ display: 'flex', gap: '6px' }}>
            <input
              type="tel"
              value={formData?.telefonPrefix || "+49"}
              onChange={e => {
                let val = e.target.value;
                if (!val.startsWith('+')) val = '+' + val.replace(/[^0-9]/g, '');
                else val = '+' + val.slice(1).replace(/[^0-9]/g, '');
                onChange("telefonPrefix", val);
              }}
              style={{
                width: '72px',
                height: '48px',
                padding: '0 10px',
                border: '1px solid #dde1e7',
                borderRadius: '10px',
                fontFamily: 'var(--font-ui)',
                fontSize: '14px',
                fontWeight: 600,
                color: '#3E4954',
                background: '#f8fafc',
                outline: 'none',
                textAlign: 'center',
                flexShrink: 0,
              }}
            />
            <input
              type="tel"
              placeholder="151 23456789"
              value={formData?.telefon || ""}
              onChange={handleChange("telefon")}
              required
              style={{
                flex: 1,
                height: '48px',
                padding: '0 14px',
                border: errors?.telefon ? '1px solid #dc2626' : '1px solid #dde1e7',
                borderRadius: '10px',
                fontFamily: 'var(--font-ui)',
                fontSize: '14px',
                color: '#1e2b38',
                background: '#ffffff',
                outline: 'none',
                transition: 'border-color 200ms ease',
                boxShadow: errors?.telefon ? '0 0 0 3px rgba(220,38,38,0.08)' : 'none',
              }}
            />
          </div>
          {errors?.telefon && (
            <p style={{ fontSize: '12px', color: '#dc2626', marginTop: '4px', fontFamily: 'var(--font-ui)' }}>{errors?.telefon}</p>
          )}
        </div>

        <div style={{ marginBottom: '28px' }}>
          <LightInput
            label={tc.wohnort}
            placeholder="z.B. Wülfrath"
            value={formData?.wohnort || ""}
            onChange={handleChange("wohnort")}
            error={undefined}
            required={false}
          />
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button type="button" onClick={onBack} className="btn-outline" style={{ flex: 1 }}>
            {tc.back}
          </button>
          <button type="submit" className="btn-primary" style={{ flex: 2 }}>
            {tc.next}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
};

export default StepContactForm;